export default "__VITE_ASSET__BsYZqLYy__"